// extracted by mini-css-extract-plugin
module.exports = {"phoneNumber":"IntlPhoneNumberField_phoneNumber__1qtPz","dropdownHidden":"IntlPhoneNumberField_dropdownHidden__WiX5g"};